import React from 'react';
import { SectionWrapper } from '../styles';
import {
	Title,
	Header,
	ButtonWrapper,
	LoadingContainer,
	TableWrapper,
} from './CommonVendors.styles';
import { EXPORT_OPTIONS } from '../constants';
import { CommonVendorsChart } from './CommonVendorsChart';
import CommonVendorsTableContainer from './CommonVendorsTable';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { convertToArray } from 'Details/utils';
import { getFormattedSpendWithSymbol } from 'utils/number';
import {
	getTopCommonVendors,
	exportCommonVendorsData,
	exportTopCommonVendors,
} from 'utils/apiRequests';
import { CHART_COLORS } from 'styles/colors';
import {
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
} from '@alixpartners/ui-components';
import isEqual from 'lodash/isEqual';

export class CommonVendors extends React.Component {
	state = { chartData: null };
	chartRef = React.createRef();

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		const { queryParams } = this.props;

		if (!isEqual(queryParams, prevProps.queryParams)) {
			this.fetchData();
		}
	}

	fetchData = () => {
		const { queryParams } = this.props;

		getTopCommonVendors(queryParams).then(chartData => {
			this.setState({ chartData });
		});
	};

	getSeriesData = () => {
		const { chartData } = this.state;
		const { companies } = this.props;

		return companies.map((company, index) => {
			return {
				name: company,
				color: CHART_COLORS[index],
				data: chartData.map(item => {
					const current = item.companies.find(i => i.name === company) || {};

					return {
						y: current.spend || 0,
						value: current.spend || 0,
						company,
					};
				}),
			};
		});
	};

	getCategories = () => {
		const { chartData } = this.state;

		return chartData.map(({ vendorName }) => vendorName);
	};

	spendFormatter = (value, withZero) => {
		const { currencySymbol } = this.props;

		return value || withZero
			? getFormattedSpendWithSymbol(value, currencySymbol).toUpperCase()
			: '-';
	};

	getChartInstance = () => {
		return (
			this.chartRef && this.chartRef.current && this.chartRef.current.chart
		);
	};

	handleChartExport = option => {
		const chartInstance = this.getChartInstance();

		if (chartInstance && option.value === 'png') {
			chartInstance.exportChart(
				{
					filename: 'SXR-Top_10_common-vendors',
				},
				{
					chart: { width: 1200 },
				}
			);
		}

		if (option.value === 'xlsx') {
			this.handleChartDataExport();
		}
	};

	handleChartDataExport = () => {
		const {
			onDownloadStart,
			onDownloadSuccess,
			onDownloadError,
			queryParams,
		} = this.props;

		onDownloadStart();
		exportTopCommonVendors(queryParams)
			.catch(onDownloadError)
			.finally(onDownloadSuccess);
	};

	handleTableDataExport = () => {
		const {
			onDownloadStart,
			onDownloadSuccess,
			onDownloadError,
			queryParams,
		} = this.props;

		onDownloadStart();
		exportCommonVendorsData(queryParams)
			.catch(onDownloadError)
			.finally(onDownloadSuccess);
	};

	render() {
		const {
			companies,
			queryParams,
			showExplorePage,
			pmiBreadcrumbs,
		} = this.props;
		const { chartData } = this.state;

		return (
			<SectionWrapper>
				<Header>
					<Title>Top 10 common vendors</Title>
					<ButtonWrapper>
						<ApSimpleDropdown
							iconName="outline_save_alt"
							onChange={this.handleChartExport}
							options={EXPORT_OPTIONS}
							label="Export"
						/>
					</ButtonWrapper>
				</Header>
				{!chartData ? (
					<LoadingContainer>
						<ApLoaderDefault loaderText={() => <ApLoaderText />} />
					</LoadingContainer>
				) : (
					<CommonVendorsChart
						companies={companies}
						spendFormatter={this.spendFormatter}
						series={this.getSeriesData()}
						categories={this.getCategories()}
						chartRef={this.chartRef}
					/>
				)}

				<TableWrapper>
					<Header>
						<Title>Top vendors</Title>
						<ButtonWrapper>
							<ApSimpleDropdown
								iconName="outline_save_alt"
								onChange={this.handleTableDataExport}
								options={[EXPORT_OPTIONS[1]]}
								label="Export"
							/>
						</ButtonWrapper>
					</Header>
					<CommonVendorsTableContainer
						queryParams={queryParams}
						companies={companies}
						spendFormatter={this.spendFormatter}
						showExplorePage={showExplorePage}
						pmiBreadcrumbs={pmiBreadcrumbs}
					/>
				</TableWrapper>
			</SectionWrapper>
		);
	}
}

export default props => (
	<QueryStringContext.Consumer>
		{({ companies }) => (
			<CommonVendors companies={convertToArray(companies)} {...props} />
		)}
	</QueryStringContext.Consumer>
);
